import React, { useState } from 'react';
import {
  Box,
  Button,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Chip,
  TablePagination,
  TextField,
  Card,
  CardContent,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  IconButton,
  Tooltip,
  Tabs,
  Tab,
} from '@mui/material';
import {
  Search,
  Visibility,
  Home,
  AttachMoney,
  Business,
  CheckCircle,
  Warning,
  LocationOn,
  Info,
} from '@mui/icons-material';

const PlotAvailability = () => {
  const [searchForm, setSearchForm] = useState({
    site: '',
    sector: '',
    block: '',
    status: '',
  });
  
  const [showPlotList, setShowPlotList] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [tableSearchQuery, setTableSearchQuery] = useState('');
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [selectedPlot, setSelectedPlot] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  
  // Sample plot availability data - this would come from API
  const [plotData] = useState([
    {
      id: 1,
      plotNo: 'P101',
      siteName: 'Green Valley',
      sectorName: 'Sector A',
      blockName: 'Block 1',
      plotSize: '30x40 ft',
      plotArea: '1200 sq ft',
      rate: '₹4,500/sq ft',
      totalAmount: '₹54,00,000',
      status: 'Available',
    },
    {
      id: 2,
      plotNo: 'P102',
      siteName: 'Green Valley',
      sectorName: 'Sector A',
      blockName: 'Block 1',
      plotSize: '25x50 ft',
      plotArea: '1250 sq ft',
      rate: '₹4,500/sq ft',
      totalAmount: '₹56,25,000',
      status: 'Hold',
    },
    {
      id: 3,
      plotNo: 'P205',
      siteName: 'Hill View',
      sectorName: 'Sector B',
      blockName: 'Block 2',
      plotSize: '35x45 ft',
      plotArea: '1575 sq ft',
      rate: '₹5,200/sq ft',
      totalAmount: '₹81,90,000',
      status: 'Booked',
    },
    {
      id: 4,
      plotNo: 'P321',
      siteName: 'Paradise Heights',
      sectorName: 'Sector C',
      blockName: 'Block 3',
      plotSize: '40x50 ft',
      plotArea: '2000 sq ft',
      rate: '₹6,000/sq ft',
      totalAmount: '₹1,20,00,000',
      status: 'Available',
    },
    {
      id: 5,
      plotNo: 'P456',
      siteName: 'Royal Gardens',
      sectorName: 'Sector D',
      blockName: 'Block 4',
      plotSize: '45x55 ft',
      plotArea: '2475 sq ft',
      rate: '₹7,500/sq ft',
      totalAmount: '₹1,85,62,500',
      status: 'Available',
    },
    {
      id: 6,
      plotNo: 'P087',
      siteName: 'Green Valley',
      sectorName: 'Sector A',
      blockName: 'Block 1',
      plotSize: '28x42 ft',
      plotArea: '1176 sq ft',
      rate: '₹4,500/sq ft',
      totalAmount: '₹52,92,000',
      status: 'Hold',
    },
    {
      id: 7,
      plotNo: 'P789',
      siteName: 'Green Valley',
      sectorName: 'Sector B',
      blockName: 'Block 2',
      plotSize: '32x48 ft',
      plotArea: '1536 sq ft',
      rate: '₹4,800/sq ft',
      totalAmount: '₹73,72,800',
      status: 'Booked',
    },
    {
      id: 8,
      plotNo: 'P654',
      siteName: 'Hill View',
      sectorName: 'Sector B',
      blockName: 'Block 2',
      plotSize: '38x52 ft',
      plotArea: '1976 sq ft',
      rate: '₹5,200/sq ft',
      totalAmount: '₹1,02,75,200',
      status: 'Available',
    },
    {
      id: 9,
      plotNo: 'P432',
      siteName: 'Paradise Heights',
      sectorName: 'Sector C',
      blockName: 'Block 3',
      plotSize: '42x58 ft',
      plotArea: '2436 sq ft',
      rate: '₹6,000/sq ft',
      totalAmount: '₹1,46,16,000',
      status: 'Available',
    },
    {
      id: 10,
      plotNo: 'P567',
      siteName: 'Royal Gardens',
      sectorName: 'Sector D',
      blockName: 'Block 4',
      plotSize: '48x60 ft',
      plotArea: '2880 sq ft',
      rate: '₹7,500/sq ft',
      totalAmount: '₹2,16,00,000',
      status: 'Hold',
    },
    {
      id: 11,
      plotNo: 'P890',
      siteName: 'Green Valley',
      sectorName: 'Sector A',
      blockName: 'Block 1',
      plotSize: '25x40 ft',
      plotArea: '1000 sq ft',
      rate: '₹4,500/sq ft',
      totalAmount: '₹45,00,000',
      status: 'Booked',
    },
    {
      id: 12,
      plotNo: 'P123',
      siteName: 'Hill View',
      sectorName: 'Sector B',
      blockName: 'Block 2',
      plotSize: '40x55 ft',
      plotArea: '2200 sq ft',
      rate: '₹5,200/sq ft',
      totalAmount: '₹1,14,40,000',
      status: 'Available',
    },
  ]);

  // Sample dropdown options
  const siteOptions = ['Green Valley', 'Hill View', 'Paradise Heights', 'Royal Gardens'];
  const sectorOptions = ['Sector A', 'Sector B', 'Sector C', 'Sector D'];
  const blockOptions = ['Block 1', 'Block 2', 'Block 3', 'Block 4'];
  const statusOptions = ['Available', 'Hold', 'Booked'];

  const handleInputChange = (field, value) => {
    setSearchForm({
      ...searchForm,
      [field]: value,
    });
  };

  const handleSearch = async () => {
    setSearchLoading(true);
    
    // Simulate API call
    setTimeout(() => {
      setShowPlotList(true);
      setPage(0); // Reset to first page when searching
      console.log('Searching with criteria:', searchForm);
      setSearchLoading(false);
    }, 1500);
  };

  const handleView = (plot) => {
    setSelectedPlot(plot);
    setViewDialogOpen(true);
  };

  const handleCloseViewDialog = () => {
    setViewDialogOpen(false);
    setSelectedPlot(null);
  };

  const handleTabChange = (_, newValue) => {
    setTabValue(newValue);
    // Filter by status based on tab
    const statusMap = { 0: '', 1: 'Available', 2: 'Hold', 3: 'Booked' };
    setSearchForm({
      ...searchForm,
      status: statusMap[newValue],
    });
  };

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  // Enhanced filter function for plot data
  const getFilteredPlotData = () => {
    if (!showPlotList) return [];
    
    let filteredData = plotData;

    // Filter by search form criteria
    if (searchForm.site) {
      filteredData = filteredData.filter(plot => plot.siteName === searchForm.site);
    }
    if (searchForm.sector) {
      filteredData = filteredData.filter(plot => plot.sectorName === searchForm.sector);
    }
    if (searchForm.block) {
      filteredData = filteredData.filter(plot => plot.blockName === searchForm.block);
    }
    if (searchForm.status) {
      filteredData = filteredData.filter(plot => plot.status === searchForm.status);
    }

    // Filter by table search query
    if (tableSearchQuery.trim()) {
      filteredData = filteredData.filter(plot =>
        Object.values(plot).some(value =>
          String(value).toLowerCase().includes(tableSearchQuery.toLowerCase())
        )
      );
    }

    return filteredData;
  };

  // Get search summary for display
  const getSearchSummary = () => {
    const criteria = [];
    if (searchForm.site) criteria.push(`Site: "${searchForm.site}"`);
    if (searchForm.sector) criteria.push(`Sector: "${searchForm.sector}"`);
    if (searchForm.block) criteria.push(`Block: "${searchForm.block}"`);
    if (searchForm.status) criteria.push(`Status: "${searchForm.status}"`);
    
    return criteria.length > 0 ? criteria.join(', ') : 'All Plots';
  };

  const getStatusStyle = (status) => {
    switch (status) {
      case 'Available':
        return {
          backgroundColor: '#4caf50',
          color: 'white',
        };
      case 'Hold':
        return {
          backgroundColor: '#ff9800',
          color: 'white',
        };
      case 'Booked':
        return {
          backgroundColor: '#f44336',
          color: 'white',
        };
      default:
        return {};
    }
  };

  // Calculate statistics
  const totalPlots = plotData.length;
  const availableCount = plotData.filter(plot => plot.status === 'Available').length;
  const holdCount = plotData.filter(plot => plot.status === 'Hold').length;
  const bookedCount = plotData.filter(plot => plot.status === 'Booked').length;
  const totalValue = plotData.reduce((sum, plot) => {
    const amount = parseFloat(plot.totalAmount.replace(/[₹,]/g, ''));
    return sum + amount;
  }, 0);

  const getFilteredByStatus = (status) => {
    return getFilteredPlotData().filter(plot => !status || plot.status === status);
  };

  return (
  <Box sx={{ p: 3, backgroundColor: '#fafafa', minHeight: 'auto' }}>
      {/* Header Section */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, color: '#000', mb: 0.5 }}>
          Plot Availability Management
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Search and view available plots across all sites and sectors
        </Typography>
      </Box>

      {/* Summary Cards */}
      {/* <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} md={3}>
          <Card sx={{ p: 3, backgroundColor: '#e3f2fd', border: '1px solid #90caf9' }}>
            <Box display="flex" alignItems="center" gap={2}>
              <Home sx={{ color: '#1976d2', fontSize: 32 }} />
              <Box>
                <Typography variant="body2" color="text.secondary">Total Plots</Typography>
                <Typography variant="h4" sx={{ fontWeight: 700, color: '#1976d2' }}>
                  {totalPlots}
                </Typography>
              </Box>
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card sx={{ p: 3, backgroundColor: '#e8f5e9', border: '1px solid #c8e6c9' }}>
            <Box display="flex" alignItems="center" gap={2}>
              <CheckCircle sx={{ color: '#2e7d32', fontSize: 32 }} />
              <Box>
                <Typography variant="body2" color="text.secondary">Available Plots</Typography>
                <Typography variant="h4" sx={{ fontWeight: 700, color: '#2e7d32' }}>
                  {availableCount}
                </Typography>
              </Box>
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card sx={{ p: 3, backgroundColor: '#fff3e0', border: '1px solid #ffcc02' }}>
            <Box display="flex" alignItems="center" gap={2}>
              <Warning sx={{ color: '#f57c00', fontSize: 32 }} />
              <Box>
                <Typography variant="body2" color="text.secondary">On Hold Plots</Typography>
                <Typography variant="h4" sx={{ fontWeight: 700, color: '#f57c00' }}>
                  {holdCount}
                </Typography>
              </Box>
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card sx={{ p: 3, backgroundColor: '#ffebee', border: '1px solid #ffcdd2' }}>
            <Box display="flex" alignItems="center" gap={2}>
              <Business sx={{ color: '#d32f2f', fontSize: 32 }} />
              <Box>
                <Typography variant="body2" color="text.secondary">Booked Plots</Typography>
                <Typography variant="h4" sx={{ fontWeight: 700, color: '#d32f2f' }}>
                  {bookedCount}
                </Typography>
              </Box>
            </Box>
          </Card>
        </Grid>
      </Grid> */}

      {/* Search Section */}
      <Card sx={{ mb: 4, boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 2 }}>
        <CardContent sx={{ p: 4 }}>
          <Box display="flex" alignItems="center" gap={2} mb={3}>
            <Search sx={{ color: '#1976d2', fontSize: 28 }} />
            <Typography variant="h5" sx={{ fontWeight: 700, color: '#000' }}>
              Search Plots
            </Typography>
          </Box>
          
          <Grid container spacing={3}>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Site</InputLabel>
                <Select
                  value={searchForm.site}
                  label="Site"
                  onChange={(e) => handleInputChange('site', e.target.value)}
                  sx={{ borderRadius: 2 }}
                >
                  <MenuItem value="">All Sites</MenuItem>
                  {siteOptions.map((site) => (
                    <MenuItem key={site} value={site}>
                      {site}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Sector</InputLabel>
                <Select
                  value={searchForm.sector}
                  label="Sector"
                  onChange={(e) => handleInputChange('sector', e.target.value)}
                  sx={{ borderRadius: 2 }}
                >
                  <MenuItem value="">All Sectors</MenuItem>
                  {sectorOptions.map((sector) => (
                    <MenuItem key={sector} value={sector}>
                      {sector}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Block</InputLabel>
                <Select
                  value={searchForm.block}
                  label="Block"
                  onChange={(e) => handleInputChange('block', e.target.value)}
                  sx={{ borderRadius: 2 }}
                >
                  <MenuItem value="">All Blocks</MenuItem>
                  {blockOptions.map((block) => (
                    <MenuItem key={block} value={block}>
                      {block}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Status</InputLabel>
                <Select
                  value={searchForm.status}
                  label="Status"
                  onChange={(e) => handleInputChange('status', e.target.value)}
                  sx={{ borderRadius: 2 }}
                >
                  <MenuItem value="">All Status</MenuItem>
                  {statusOptions.map((status) => (
                    <MenuItem key={status} value={status}>
                      {status}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSearch}
                  disabled={searchLoading}
                  startIcon={<Search />}
                  sx={{ 
                    px: 4, 
                    py: 1.5,
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: '15px',
                    boxShadow: '0 4px 12px rgba(83, 109, 254, 0.3)',
                    borderRadius: 2
                  }}
                >
                  {searchLoading ? 'Searching...' : 'Search Plots'}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Tab Navigation */}
      <Card sx={{ mb: 4, boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 2 }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tabValue} onChange={handleTabChange} sx={{ px: 3 }}>
            <Tab label={`All Plots (${getFilteredByStatus('').length})`} />
            <Tab label={`Available (${getFilteredByStatus('Available').length})`} />
            <Tab label={`Hold (${getFilteredByStatus('Hold').length})`} />
            <Tab label={`Booked (${getFilteredByStatus('Booked').length})`} />
          </Tabs>
        </Box>
      </Card>

      {/* Plot Availability Table */}
      {showPlotList && (
        <Card sx={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 2 }}>
          <CardContent sx={{ p: 0 }}>
            <Box sx={{ p: 3, borderBottom: '1px solid #e0e0e0' }}>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box display="flex" alignItems="center" gap={2}>
                  <LocationOn sx={{ color: '#1976d2', fontSize: 24 }} />
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    Plot Availability Results
                  </Typography>
                </Box>
                <TextField
                  label="Search Plots..."
                  variant="outlined"
                  size="small"
                  value={tableSearchQuery}
                  onChange={(e) => setTableSearchQuery(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search color="action" />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ width: 250, borderRadius: 2 }}
                />
              </Box>
              
              <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                Search Criteria: {getSearchSummary()}
              </Typography>
              <Typography variant="body2" color="primary" sx={{ mt: 1, fontWeight: 600 }}>
                Found {getFilteredPlotData().length} plot(s) matching your search criteria
              </Typography>
            </Box>
            
            {getFilteredPlotData().length > 0 ? (
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: '#f8f9fa' }}>
                      <TableCell sx={{ fontWeight: 700, color: '#1976d2' }}>S.No</TableCell>
                      <TableCell sx={{ fontWeight: 700, color: '#1976d2' }}>Plot Info</TableCell>
                      <TableCell sx={{ fontWeight: 700, color: '#1976d2' }}>Location</TableCell>
                      <TableCell sx={{ fontWeight: 700, color: '#1976d2' }}>Dimensions</TableCell>
                      <TableCell sx={{ fontWeight: 700, color: '#1976d2' }}>Pricing</TableCell>
                      <TableCell sx={{ fontWeight: 700, color: '#1976d2' }}>Status</TableCell>
                      <TableCell sx={{ fontWeight: 700, color: '#1976d2' }}>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {getFilteredPlotData()
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((plot, index) => (
                        <TableRow key={plot.id} hover>
                          <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                          <TableCell>
                            <Box>
                              <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'primary.main' }}>
                                {plot.plotNo}
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                ID: {plot.id}
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box>
                              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                {plot.siteName}
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                {plot.sectorName} • {plot.blockName}
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box>
                              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                {plot.plotSize}
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                {plot.plotArea}
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box>
                              <Typography variant="body2" sx={{ fontWeight: 600, color: 'secondary.main' }}>
                                {plot.rate}
                              </Typography>
                              <Typography variant="body2" sx={{ fontWeight: 700, color: 'success.main' }}>
                                {plot.totalAmount}
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={plot.status}
                              sx={getStatusStyle(plot.status)}
                              size="small"
                            />
                          </TableCell>
                          <TableCell>
                            <Tooltip title="View Plot Details">
                              <IconButton
                                color="primary"
                                onClick={() => handleView(plot)}
                                size="small"
                              >
                                <Visibility />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Box sx={{ textAlign: 'center', py: 6 }}>
                <Alert severity="warning" sx={{ mx: 3, mb: 3, borderRadius: 2 }}>
                  <Typography variant="h6" gutterBottom>
                    No Plots Found
                  </Typography>
                  <Typography variant="body2">
                    No plots match your search criteria: {getSearchSummary()}
                  </Typography>
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    Please try different search criteria.
                  </Typography>
                </Alert>
              </Box>
            )}

            {/* Pagination */}
            <TablePagination
              
              component="div"
              count={getFilteredPlotData().length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{ px: 3, py: 2 }}
            />
          </CardContent>
        </Card>
      )}

      {/* Plot Details Dialog */}
      <Dialog 
        open={viewDialogOpen} 
        onClose={handleCloseViewDialog} 
        maxWidth="md" 
        fullWidth
        PaperProps={{
          sx: { borderRadius: 2 }
        }}
      >
        <DialogTitle sx={{ 
          fontSize: '24px', 
          fontWeight: 700, 
          color: '#000',
          borderBottom: '1px solid #e0e0e0',
          pb: 2
        }}>
          <Box display="flex" alignItems="center" gap={2}>
            <Home sx={{ color: '#1976d2', fontSize: 28 }} />
            Plot Details
          </Box>
        </DialogTitle>
        
        <DialogContent sx={{ p: 3 }}>
          {selectedPlot && (
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Card sx={{ p: 2, backgroundColor: '#e3f2fd', border: '1px solid #90caf9' }}>
                  <Box display="flex" alignItems="center" gap={2} mb={2}>
                    <Info sx={{ color: '#1976d2', fontSize: 20 }} />
                    <Typography variant="h6" sx={{ fontWeight: 600, color: '#1976d2' }}>
                      Plot Information
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="body2" color="text.secondary">Plot Number</Typography>
                    <Typography variant="h6" sx={{ fontWeight: 600, color: 'primary.main', mb: 2 }}>
                      {selectedPlot.plotNo}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">Plot Size</Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                      {selectedPlot.plotSize}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">Plot Area</Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      {selectedPlot.plotArea}
                    </Typography>
                  </Box>
                </Card>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <Card sx={{ p: 2, backgroundColor: '#e8f5e9', border: '1px solid #c8e6c9' }}>
                  <Box display="flex" alignItems="center" gap={2} mb={2}>
                    <LocationOn sx={{ color: '#2e7d32', fontSize: 20 }} />
                    <Typography variant="h6" sx={{ fontWeight: 600, color: '#2e7d32' }}>
                      Location Details
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="body2" color="text.secondary">Site Name</Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                      {selectedPlot.siteName}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">Sector</Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                      {selectedPlot.sectorName}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">Block</Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      {selectedPlot.blockName}
                    </Typography>
                  </Box>
                </Card>
              </Grid>
              
              <Grid item xs={12}>
                <Card sx={{ p: 2, backgroundColor: '#fff3e0', border: '1px solid #ffcc02' }}>
                  <Box display="flex" alignItems="center" gap={2} mb={2}>
                    <AttachMoney sx={{ color: '#f57c00', fontSize: 20 }} />
                    <Typography variant="h6" sx={{ fontWeight: 600, color: '#f57c00' }}>
                      Financial Details
                    </Typography>
                  </Box>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={4}>
                      <Typography variant="body2" color="text.secondary">Rate per sq ft</Typography>
                      <Typography variant="h6" sx={{ fontWeight: 600, color: '#f57c00' }}>
                        {selectedPlot.rate}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Typography variant="body2" color="text.secondary">Total Amount</Typography>
                      <Typography variant="h6" sx={{ fontWeight: 600, color: '#f57c00' }}>
                        {selectedPlot.totalAmount}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Typography variant="body2" color="text.secondary">Status</Typography>
                      <Chip
                        label={selectedPlot.status}
                        sx={getStatusStyle(selectedPlot.status)}
                        size="small"
                      />
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        
        <DialogActions sx={{ p: 3, gap: 2, borderTop: '1px solid #e0e0e0' }}>
          <Button 
            onClick={handleCloseViewDialog}
            variant="outlined"
            sx={{ 
              textTransform: 'none',
              fontWeight: 600,
              px: 3
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default PlotAvailability;